import { useState, useCallback } from "react";
import { useAlert } from "../functions/useAlert";
import { fetchContactsByClient } from "../services/contacts.service";
import { Contact } from "../components/client/types";

export function useClientContacts() {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [setAlert] = useAlert();

  const fetchFor = useCallback(async (clientId: string | null) => {
    if (!clientId) {
      setContacts([]);
      return;
    }
    setIsLoading(true);
    try {
      const response: any = await fetchContactsByClient(clientId);
      setContacts(response.data || []);
    } catch (error: any) {
      setContacts([]);
      if (error.status === 403) {
        setAlert(
          "Access Denied: You don't have permission to view this client's contacts.",
          "error",
        );
      } else if (error.status === 401) {
        setAlert("Session expired. Please login again.", "error");
      } else {
        setAlert(error.message || "Failed to fetch linked contacts.", "error");
      }
    } finally {
      setIsLoading(false);
    }
  }, [setAlert]);

  const clear = useCallback(() => setContacts([]), []);

  return { contacts, isLoading, fetchFor, clear };
}
